import type { ResolvedTheme } from './constants';

let lockedTheme: ResolvedTheme | null = null;

function writeThemeClass(theme: ResolvedTheme): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

export function applyDocumentTheme(theme: ResolvedTheme): void {
  writeThemeClass(lockedTheme ?? theme);
}

export function lockDocumentTheme(theme: ResolvedTheme): void {
  lockedTheme = theme;
  writeThemeClass(theme);
}

export function unlockDocumentTheme(restore?: ResolvedTheme): void {
  lockedTheme = null;
  if (restore) writeThemeClass(restore);
}
